import React from 'react';
import { FormikTouched, FormikValues, FormikErrors } from 'formik';
import { Alert, Button, Field, HeaderSection } from '@groupelacentrale/contact-storybook';
import './LoginForm.scss';

interface Props {
  email: string;
  password: string;
  isSubmitting: boolean;
  errorMessage: string;
  touched: FormikTouched<FormikValues>;
  errors: FormikErrors<FormikValues>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const LoginFormView: React.FC<Props> = ({
  email,
  password,
  isSubmitting,
  errorMessage,
  touched,
  errors,
  handleChange,
  handleSubmit,
}) => (
  <form className="login-form" onSubmit={handleSubmit}>
    <HeaderSection noUnderline>Connectez-vous</HeaderSection>
    <Field
      name="email"
      placeholder="Adresse email"
      value={email}
      onChange={handleChange}
      errorMessage={touched.email ? errors.email : undefined}
    />
    <Field
      name="password"
      type="password"
      placeholder="Mot de passe"
      value={password}
      onChange={handleChange}
      errorMessage={touched.email ? errors.password : undefined}
    />
    <Button label="Se connecter" type="submit" theme="primary" disabled={isSubmitting} loading={isSubmitting} />
    {errorMessage && <Alert type="error">{errorMessage} </Alert>}
  </form>
);
